import styled from 'styled-components';
import { orange } from '../../../../style/colors';

export const CheckboxContainer = styled.label`
  display: flex;
  align-items: center;
  padding: 8px 10px;
  cursor: pointer;
  font-size: 14px;
  color: #555;
  transition: all 0.2s;
  border-radius: 8px;
  margin-bottom: 4px;
  user-select: none;

  &:hover {
    background-color: #fff5f0;
    transform: translateX(2px);
  }

  input[type='checkbox'] {
    margin-right: 12px;
    width: 20px;
    height: 20px;
    cursor: pointer;
    accent-color: ${orange};
    border-radius: 6px;
  }

  input[type='checkbox']:checked + span {
    font-weight: 600;
    color: #222;
  }

  span {
    user-select: none;
  }
`;


